import HeaderRegister from "../../../../components/header/register";
import FormStoreCatalog from "../form";

const MainRegisterStoreCatalog = () => {
	const options = {
		title: "Configuração do Catálogo",
		subTitle: "Vendas Online",
	};

	return (
		<div className="mt-page">
			<HeaderRegister title={options.title} subTitle={options.subTitle} />
			<FormStoreCatalog />
		</div>
	);
};

export default MainRegisterStoreCatalog;
